import React from 'react';

import * as Match from '../match';
import * as Styled from './StyledMatches';

export const Matches = ({ matches, t }) => (
    <Styled.Matches>
        <Styled.MatchesThead>
            <Styled.MatchesTr>
                <Styled.MatchesTh>{t('feedbacks.Matches.evaluator')}</Styled.MatchesTh>
                <Styled.MatchesTh>{t('feedbacks.Matches.feedback')}</Styled.MatchesTh>
                <Styled.MatchesTh>{t('feedbacks.Matches.received')}</Styled.MatchesTh>
                <Styled.MatchesTh>{t('feedbacks.Matches.action')}</Styled.MatchesTh>
                <Styled.MatchesTh>{t('feedbacks.Matches.connection')}</Styled.MatchesTh>
            </Styled.MatchesTr>
        </Styled.MatchesThead>

        <Styled.MatchesTbody>
            {matches.map(match => (
                <Styled.MatchesTr key={match._id}>
                    <Styled.MatchesTd>
                        <Match.MatchEvaluator match={match} />
                    </Styled.MatchesTd>

                    <Styled.MatchesTd>
                        <Match.MatchFeedback match={match} />
                    </Styled.MatchesTd>

                    <Styled.MatchesTd>
                        <Match.MatchReceived match={match} />
                    </Styled.MatchesTd>

                    <Styled.MatchesTd>
                        <Match.MatchAction match={match} />
                    </Styled.MatchesTd>

                    <Styled.MatchesTd>
                        <Match.MatchConnection match={match} />
                    </Styled.MatchesTd>
                </Styled.MatchesTr>
            ))}
        </Styled.MatchesTbody>
    </Styled.Matches>
);
